var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.1281 10.2666H2.35721C1.34736 10.4349 0.50582 11.1081 0.50582 12.118C0.337512 13.2961 1.17905 14.306 2.35721 14.306H30.1281C31.1379 14.1377 31.9795 13.4645 31.9795 12.4546C31.9795 11.2765 31.1379 10.2666 30.1281 10.2666Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.35721 4.0394H30.1281C31.1379 3.87109 31.9794 3.19786 31.9794 2.18801C32.1478 1.00985 31.3062 0 30.1281 0H2.35721C1.34736 0.168308 0.50582 0.841542 0.50582 1.85139C0.337512 2.86124 1.17905 3.87109 2.35721 4.0394Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.1272 20.5332H2.35631C2.18801 20.5332 2.18801 20.5332 2.0197 20.5332C0.841541 20.7015 0 21.7114 0 22.7212C0.168308 23.8994 1.17816 24.7409 2.18801 24.5726H29.9589C30.9687 24.4043 31.8102 23.7311 31.8102 22.7212C31.9786 21.7114 31.137 20.7015 30.1272 20.5332Z",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamBurgerIcon);
export default __webpack_public_path__ + "static/media/hamBurgerIcon.b6690db3a1e61dd32486380ad24ef70b.svg";
export { ForwardRef as ReactComponent };